var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"standard-dialog-fullscreen",style:(`${_vm.full_element?`
      height: 100%;
      width: 100%;
      margin-top: 0px;
      margin-left: 0px;
      top: 0px;
      left: 0px;
      `:
      `height: ${_vm.getHeight()}px !important;
      `
      }
      ${_vm.opacity?`background-color: rgba(0,0,0, ${_vm.opacity})`:''}
      `)},[_c('transition',{attrs:{"name":"dialog_slide"}},[_vm._t("dialog")],2),_c('div',{staticClass:"standard-dialog-fullscreen-header t-shadow color-4",style:(`${_vm.header_max_height?'height: ' + _vm.header_max_height + 'px;':''}`)},[_c('div',{staticClass:"standard-dialog-fullscreen-header-workpackages"},[_vm._t("header-workpackages")],2),_c('div',{staticClass:"standard-dialog-fullscreen-header-text"},[_vm._t("header-text")],2),_c('div',{staticClass:"standard-dialog-fullscreen-header-close"},[_vm._t("header-close")],2)]),_c('div',{staticClass:"nav-left self-centered"},[_vm._t("nav-left")],2),_c('div',{staticClass:"nav-right self-centered"},[_vm._t("nav-right")],2),_c('div',{staticClass:"standard-dialog-fullscreen-content",style:(`${_vm.header_max_height?`height: calc(100% - ${_vm.header_max_height}px);`:''}
      ${_vm.overflow_auto?'overflow: auto;':''}
      `)},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }